module.exports = __webpack_public_path__ + "img/go.9c1a7b98.png";